import React from 'react'
import { MDBRow, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText ,MDBCol, MDBCardImage, MDBContainer, MDBBtn} from 'mdbreact'

export default function milkProducts() {
    return (
        <div>
         <section style={{backgroundImage:"url(https://images.pexels.com/photos/2064357/pexels-photo-2064357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)"}}>
 
             <MDBContainer className="p-5">
                 <br  />
             <MDBRow className="py-5">
             <br  />
                 <MDBCol md="6">
                 <h1 class="mb-4">our <span class="text-danger">the best rated</span>
               <span class="cyan-text">Milk Products</span> near you.</h1>
            <p class="mb-4 pb-2 dark-grey-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam vitae, culpa qui officia deserunt laborum fuga similique mollit id quos aperiam proident non ut rerum debitis.</p>
          	<button type="button" class="btn btn-primary btn-rounded btn-md ml-md-0">Get started</button>
 
                 </MDBCol>
                 <MDBCol md="4" sm="12">
                        <img src="https://www.bigbasket.com/media/uploads/p/l/273238_2-visakha-dairy-uht-milk-shakti.jpg" class="img-fluid"/>
                 </MDBCol>
             </MDBRow>
    
             </MDBContainer>

            
         </section>
         <section  className="">
             <br   />
             <MDBContainer className="p-5">
                 <MDBRow>
               
                     <MDBCol  className="" md="4" sm="12">
                     <br  />
            <MDBCard className="hoverable zoomIn" >
             <MDBCardImage
             
               src=
                  "http://www.visakhadairy.com/images/p2.jpg"
            className="img-fluid" style={{
                  backgroundPosition: "middle",
                  backgroundRepeat:" no-repeat",
                  backgroundSize:"cover"
              
                  }}/ >
            <MDBCardBody>
            <a type="button" href="/milkProductDetails" class="btn  btn-info  btn-rounded btn-md">view</a>
            </MDBCardBody>
            </MDBCard>
           
                     </MDBCol>
                     
                     <MDBCol   className="" md="4" sm="12">
                     <br  />
                     <MDBCard className="hoverable zoomIn">
             <MDBCardImage  src=
                  "http://www.visakhadairy.com/images/p2.jpg"
            className="img-fluid" style={{
                  backgroundPosition: "middle",
                  backgroundRepeat:" no-repeat",
                  backgroundSize:"cover"
              
                  }}/ >
          
            </MDBCard>
                     </MDBCol>
                  
                     <MDBCol  className="" md="4" sm="12">
                     <br  />
                     <MDBCard className="hoverable zoomIn">
             <MDBCardImage  src=
                  "http://www.visakhadairy.com/images/p3.jpg"
            className="img-fluid" style={{
                  backgroundPosition: "middle",
                  backgroundRepeat:" no-repeat",
                  backgroundSize:"cover"
              
                  }}/ >
          
            </MDBCard>
                     </MDBCol>
                 </MDBRow>
             
             </MDBContainer>
         </section>
        </div>
    )
}
